import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { AsyncButtonEl } from 'common/components/async-button';
import { TooltipEl } from 'common/components/tooltip';
export function template() {
  const projectStoreHasFetchedValue = this.helpers.projectStoreFetched();
  return jsx("span", {
    sel: '.mp-sharing-status-button-container'
  }, this.attr("tooltip-text") ? jsx(TooltipEl, {
    attrs: {
      text: this.attr("tooltip-text"),
      offset: 10,
      'body-level': true
    }
  }) : null, !this.attr("hide-share-button") && jsx(ButtonEl, {
    sel: '.left',
    class: {
      'secondary-theme': this.attr("theme") === "secondary",
      'fully-rounded': this.attr("theme") === "tertiary"
    },
    attrs: {
      elref: "sharingStatusButton",
      theme: this.attr("theme"),
      disabled: this.helpers.isDisabled()
    },
    on: {
      click: this.helpers.handleClick
    }
  }, "Share"), jsx(AsyncButtonEl, {
    class: {
      'fully-rounded': this.attr("hide-share-button") || this.attr("theme") === "tertiary"
    },
    attrs: {
      elref: "sharingCopyLinkSplitButton",
      theme: this.attr("theme"),
      icon: !projectStoreHasFetchedValue ? "spinner" : "link",
      disabled: !projectStoreHasFetchedValue,
      'style-override': require("./async-button-override.styl?inline")
    },
    props: {
      asyncAction: this.helpers.copyLink
    }
  }));
}